import { Hidden } from '@ahmdigital/ui';

import { scrollTo } from '../../utils/ui';
import { ScrollTop, ScrollTopFixed, ScrollTopText } from './styles';

const BackToTop = () => (
  <ScrollTopFixed>
    {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
    <ScrollTop icon={{ name: 'arrow-up', position: 'right' }} onClick={scrollTo} aria-label="Back to top">
      <Hidden xs sm md>
        <ScrollTopText>Back to Top</ScrollTopText>
      </Hidden>
    </ScrollTop>
  </ScrollTopFixed>
);

export default BackToTop;
